export default __webpack_public_path__ + "static/media/iconStudent.776f3745.png";